import React from 'react'
import { renderPostureIcon } from './Icons'

export function PostureDistribution({ breakdown, compact = false }) {
  const items = breakdown || []
  const totalSec = items.reduce((a, b) => a + (b.seconds || 0), 0)
  if (totalSec === 0) return null

  if (compact) {
    return (
      <div>
        {/* Barra segmentada */}
        <div style={{ display: 'flex', borderRadius: 4, overflow: 'hidden', height: 6, marginBottom: 7 }}>
          {items.map(p => (
            p.seconds > 0 ? (
              <div
                key={p.key}
                style={{
                  flex: p.seconds,
                  background: p.color,
                  transition: 'flex 0.5s ease',
                }}
                title={`${p.label}: ${p.formatted} (${p.pct}%)`}
              />
            ) : null
          ))}
        </div>

        {/* Fila compacta de etiquetas en 2 columnas */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 8px' }}>
          {items.map(p => (
            <div key={p.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 4 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 5, minWidth: 0 }}>
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: p.color, boxShadow: `0 0 5px ${p.color}80`, flexShrink: 0 }} />
                <span style={{ fontSize: 9.5, color: 'var(--text-muted)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {p.label}
                </span>
              </div>
              <span style={{ fontSize: 9.5, fontWeight: 700, color: 'var(--text)', fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>
                {p.formatted} <span style={{ color: p.color, fontWeight: 800 }}>({p.pct}%)</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    )
  }

  // Vista completa / detallada minimalista y chica
  return (
    <div style={{ background: 'var(--card-bg)', borderRadius: 16, padding: '14px 16px', border: '1px solid var(--border-soft)', boxShadow: '0 1px 3px rgba(0,0,0,0.02)', marginBottom: 26 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
          <span style={{ fontSize: 9.5, fontWeight: 900, background: 'var(--chip-bg)', color: 'var(--text)', padding: '2px 7px', borderRadius: 6, fontVariantNumeric: 'tabular-nums' }}>
            03
          </span>
          <p style={{ fontSize: 10.5, fontWeight: 800, margin: 0, color: 'var(--text-faint)', textTransform: 'uppercase', letterSpacing: 0.6 }}>
            Distribución Biomecánica de Postura
          </p>
        </div>
        <span style={{ fontSize: 10, color: 'var(--text-faint)', fontVariantNumeric: 'tabular-nums' }}>
          Total: {formatSec(totalSec)}
        </span>
      </div>

      {/* Barra segmentada horizontal estilizada y delgada */}
      <div style={{ display: 'flex', borderRadius: 4, overflow: 'hidden', height: 6, marginBottom: 8, background: 'var(--track)' }}>
        {items.map(p => (
          p.seconds > 0 ? (
            <div
              key={p.key}
              style={{
                flex: p.seconds,
                background: p.color,
                transition: 'flex 0.5s ease',
              }}
              title={`${p.label}: ${p.formatted} (${p.pct}%)`}
            />
          ) : null
        ))}
      </div>

      {/* Micro-fichas horizontales minimalistas de una sola línea */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(115px, 1fr))', gap: 6 }}>
        {items.map(p => (
          <div
            key={p.key}
            style={{
              background: 'var(--field-bg)',
              border: 'none',
              borderRadius: 8,
              padding: '6px 10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 4,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
              <span style={{ width: 7, height: 7, borderRadius: '50%', background: p.color, boxShadow: `0 0 6px ${p.color}80`, flexShrink: 0 }} />
              <span style={{ fontSize: 10.5, fontWeight: 700, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>
                {p.label}
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 3, flexShrink: 0 }}>
              <span style={{ fontSize: 11, fontWeight: 900, color: p.color, fontVariantNumeric: 'tabular-nums' }}>
                {p.pct}%
              </span>
              <span style={{ fontSize: 9.5, fontWeight: 600, color: 'var(--text-faint)', fontVariantNumeric: 'tabular-nums' }}>
                {p.formatted}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

function formatSec(s) {
  const m = Math.floor(s / 60)
  const h = Math.floor(m / 60)
  const remM = m % 60
  if (h > 0) return `${h}h ${remM}m`
  return `${m}m ${s % 60}s`
}
